<script>
  import {FooterCommon,BizFooter} from "@util/constant.js"
  const logo_mng = "/assets_default/icons/logo-white.svg"
  import { fly } from 'svelte/transition';

  let y = $state(0)
  let x = $state(0)
  let BrowserHeight = $state(0)
</script>

<svelte:window bind:innerWidth={y} bind:scrollY={x} />

<footer class="owd-biz-footer" id="owd-biz-footer">
  <div class="owd-biz-footer-section">
    <a href="/">
      <img class="mng-logo" src="{logo_mng}" width="200" height="26" alt="Minna no Ginko">
    </a>
    <ul class="owd-biz-footer-section-nav">
      {#each BizFooter as nav}
        <li class="owd-text:02 {nav.class}"><a href={nav.href} target="_blank"><strong>{nav.label}</strong></a></li>
      {/each}
        <li class="owd-text:02 nav-link:wide"><a href={FooterCommon.policy.link} target="_blank"><strong>{FooterCommon.policy.label}</strong></a><li>
    </ul>
  </div>
  <ul class="owd-biz-footer-section-nav:sns">
    {#each FooterCommon.footerSNS as sns}
    <li>
      <a href="{sns.link}" target="_blank" rel="noopener noreferrer">
        <img src={sns.icon} alt="{sns.alt}">
      </a>
    </li>
    {/each}
  </ul>
  <div class="owd-biz-footer-section owd-biz-footer-section-copy">
    <p class="owd-information adjust-line-height">{@html FooterCommon.company}</p>
    <p class="owd-caption copylight">{@html FooterCommon.copylight}</p>
  </div>
</footer>
{#if x > 1280}
<div class="owd-button-pagetop-wrap" transition:fly={{y: 100}}>
  <a href="#" class="owd-button-pagetop">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M6.414 15.414L12 9.828L17.586 15.414L19 14L12 7L5 14L6.414 15.414Z" fill="black"/>
    </svg>
  </a>
</div>
{/if}

<style lang="scss">


.owd-biz-footer{
  width: 100%;
  background-color: var(--primary-black);
  color: var(--primary-white);
  display: grid;
  gap: 40px;
  padding: 80px 120px;
  a{
    color: var(--primary-white);
    text-decoration: none;
    @include g.hover-text-decoration($color: var(--primary-white), $offset: .5em);
  }
  &-section{
    width: 100%;
    display: flex;
    justify-content: space-between;
    &-nav{
      display: grid;
      gap: 24px;
      justify-content: space-between;
      grid-template-columns: repeat(2, 1fr);
      .nav-link{
        &\:wide{
          grid-column: 1 / -1;
        }
      }
      &\:sns{
        display: grid;
        grid-template-columns: repeat(5, 30px);
        gap: 16px;
      }
    }
    &\-copy{
      align-items: end;
      .copylight{
        font-family: g.$en;
      }
    }
  }
  @include g.mobile {
    padding: 40px 24px;
    gap: 24px;
    &-section{
    flex-direction: column-reverse;
    .mng-logo{
      max-width: 214px;
      margin-top: 64px;
    }
      &-nav{
        grid-auto-flow: row;
      }
      &\-copy{
        align-items: start;
        flex-direction: column;
        gap: 40px;
        margin-top: calc(40px - 24px);
      }
    }
  }
}
.owd-button-pagetop-wrap{
  // 要調整
  position: fixed;
  bottom: 88px;
  right: 32px;
  // z-index: 3;
  z-index: 1;
  @include g.large {
    bottom: 120px;
    right: 32px;
    width: 60px;
    height: 60px;
  }
}
</style>
